import React from 'react'

export const Pagination = ({ totalPage, pageNumber, setPageNumber }) => {
  const handlePageChange = (page) => {
    setPageNumber(page)
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1)
  }

  const goToNextPage = () => {
    if (pageNumber < totalPage) setPageNumber(pageNumber + 1)
  }

  const goToFirstPage = () => {
    setPageNumber(1)
  }

  const goToLastPage = () => {
    setPageNumber(totalPage)
  }

  const generatePageButtons = () => {
    const buttonsToShow = 5
    let startIndex = Math.max(1, pageNumber - Math.floor(buttonsToShow / 2))
    let endIndex = Math.min(totalPage, startIndex + buttonsToShow - 1)

    if (endIndex - startIndex < buttonsToShow - 1) {
      startIndex = Math.max(1, endIndex - buttonsToShow + 1)
    }

    const pageButtons = []
    for (let i = startIndex; i <= endIndex; i++) {
      pageButtons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          style={{
            margin: '0 5px',
            padding: '10px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            backgroundColor: pageNumber === i ? '#556EE6' : '',
            color: pageNumber === i ? 'white' : 'black',
            border: 'none',
            outline: 'none',
            transition: 'background-color 0.3s, color 0.3s',
          }}
          className={
            i === pageNumber
              ? "font-bold text-2xl rounded-x px-4 bg-blue-800 rounded-xl"
              : "font-semibold text-xl rounded-xl px-3  bg-blue-600"
          }
        >
          {i}
        </button>
      )
    }
    return pageButtons
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }} className='hide'>
      <span style={{ marginRight: 20, fontWeight: 'bold' }}>
        Page {pageNumber} of {totalPage}
      </span>
      <button
        onClick={goToFirstPage}
        disabled={pageNumber === 1}
        style={{
          margin: '0 5px',
          padding: '10px 15px',
          borderRadius: '5px',
          cursor: 'pointer',
          backgroundColor: 'lightgray',
          color: 'black',
          border: 'none',
          outline: 'none',
          opacity: pageNumber === 1 ? 0.5 : 1,
          pointerEvents: pageNumber === 1 ? 'none' : 'auto',
        }}
      >
        &#171; First
      </button>
      <button
        onClick={goToPrevPage}
        disabled={pageNumber === 1}
        style={{
          margin: '0 5px',
          padding: '10px 15px',
          borderRadius: '5px',
          cursor: 'pointer',
          backgroundColor: 'lightgray',
          color: 'black',
          border: 'none',
          outline: 'none',
          opacity: pageNumber === 1 ? 0.5 : 1,
          pointerEvents: pageNumber === 1 ? 'none' : 'auto',
        }}
      >
        &#8592; Prev
      </button>
      <span style={{ display: 'inline-block' }}>{generatePageButtons()}</span>
      <button
        onClick={goToNextPage}
        disabled={pageNumber === totalPage}
        style={{
          margin: '0 5px',
          padding: '10px 15px',
          borderRadius: '5px',
          cursor: 'pointer',
          backgroundColor: 'lightgray',
          color: 'black',
          border: 'none',
          outline: 'none',
          opacity: pageNumber === totalPage ? 0.5 : 1,
          pointerEvents: pageNumber === totalPage ? 'none' : 'auto',
        }}
      >
        Next &#8594;
      </button>
      <button
        onClick={goToLastPage}
        disabled={pageNumber === totalPage}
        style={{
          margin: '0 5px',
          padding: '10px 15px',
          borderRadius: '5px',
          cursor: 'pointer',
          backgroundColor: 'lightgray',
          color: 'black',
          border: 'none',
          outline: 'none',
          opacity: pageNumber === totalPage ? 0.5 : 1,
          pointerEvents: pageNumber === totalPage ? 'none' : 'auto',
        }}
      >
        Last &#187;
      </button>
    </div>
  )
}